import { useState, useEffect, useContext } from 'react';
import { getAllTimeAttendance, getCourses } from '../firebase/utils';
import StudentContext from '../Helper/Students';

const useFetchData = (loadUsersAndCourses = true) => {
  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const { allstudent, fetchAllStudents } = useContext(StudentContext);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    const fetchData = async () => {
      const promises = [
        allstudent?.length ? Promise.resolve(allstudent) : fetchAllStudents(),
        getCourses(),
        getAllTimeAttendance(),
      ];

      const [studentsResult, coursesResult, attendanceResult] = await Promise.allSettled(promises);

      if (!isMounted) return;

      if (studentsResult.status === "fulfilled") {
        setStudents(studentsResult.value);
      }

      if (coursesResult.status === "fulfilled") {
        setCourses(coursesResult.value);
      }

      if (attendanceResult.status === "fulfilled") {
        setAttendance(attendanceResult.value);
      }

      setLoading(false);
    };
    if (loadUsersAndCourses) {
      fetchData();
    } else {
      setStudents([]);
      setCourses([]);
      setAttendance([]);
      setLoading(true);
    }

    return () => {
      isMounted = false;
    };
  }, [loadUsersAndCourses]);

  return { students, setStudents, courses, attendance, loading };
};

export default useFetchData;
